import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import '../admin/styling/DataTable.css';

const DataTable = ({ data }) => {
  const [searchText, setSearchText] = useState("");


  const filteredRows = data.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const columns = [
    { field: 'serialNumber', headerName: 'Sl. No', width: 80 },
    { field: 'registrationNumber', headerName: 'Registration No', width: 145 },
    { field: 'name', headerName: 'Name', width: 160 },
    { field: 'fathersName', headerName: "Father's Name", width: 160 },
    { field: 'phone', headerName: 'Phone', width: 110 },
    { field: 'dob', headerName: 'Date of Birth', width: 130 },
    { field: 'course', headerName: 'Course', width: 70 },
    { field: 'startMonth', headerName: 'Start Date', width: 110 },
    { field: 'endMonth', headerName: 'End Date', width: 110 },
    { field: 'grade', headerName: 'Grade', width: 70 },
    { field: 'issueDate', headerName: 'Issue Date', width: 130 },

  ];

  return (
    <Box sx={{ width: '100%' }}>

      {/* ✅ Search Bar */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: 1.5,
          alignItems: 'center',
          gap: 1
        }}
      >
        <SearchIcon sx={{ color: '#1976d2' }} />
        <TextField
          size="small"
          placeholder="Search records..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{ width: '280px' }}
        />
      </Box>

      <Box sx={{ height: 600 }}>
        <DataGrid
          rows={filteredRows}
          getRowId={(row) => row.serialNumber || row.id}
          columns={columns}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
        />
      </Box>
    </Box>
  );
};

export default DataTable;
